/* eslint-disable @typescript-eslint/camelcase */
import { cloneDeep } from 'lodash'

let parentStoryBeingCloned = null
let parentCirculations = null

const setClonePropertiesOnStory = (story, reset) => {
  story.related_content = {
    ...story.related_content,
    clonedFromParent: reset ? [] : story.related_content.clonedFromParent || [],
    clonedChildren: reset ? [] : story.related_content.clonedChildren || [],
  }
}

export const createLocalCloneOfStory = (story, circulations) => {
  parentStoryBeingCloned = cloneDeep(story)

  // will be [] if !pubstackEnabled
  parentCirculations = [...circulations]

  const storyIdToBeCloned = story._id

  //  delete the story id so that a new story will be created
  delete story._id

  //  delete fields that shouldn't be copied over
  delete story.created_date
  delete story.display_date
  delete story.last_updated_date
  delete story.publish_date
  delete story.first_publish_date

  delete story.canonical_url
  delete story.additional_properties.has_published_copy
  delete story.additional_properties.is_published
  delete story.additional_properties.publish_date
  delete story.source.source_id
  delete story.source.edit_url
  story.source = {
    ...story.source,
    system: 'composer',
  }
  for (const i in story.websites) {
    delete story.websites[i].website_url
  }
  story.workflow = {}

  //  deleting story.revision is necessary for a new story to be created
  delete story.revision

  setClonePropertiesOnStory(story, true)
  story.related_content.clonedFromParent.push({
    type: 'reference',
    referent: {
      id: storyIdToBeCloned,
    },
  })

  return story
}

export const getParentStory = () => {
  return parentStoryBeingCloned
}

export const getParentCirculations = () => {
  return parentCirculations
}

export const addClonedStoryToParent = (clonedStory) => {
  setClonePropertiesOnStory(parentStoryBeingCloned)
  parentStoryBeingCloned.related_content.clonedChildren.push({
    type: 'reference',
    referent: {
      id: clonedStory._id,
    },
  })
}
